<template>
  <button-dialog-container
    :title-dialog="$t('project.blank-title')"
    btn-icon="mdi-plus"
    :btn-text="$t('project.new')"
    :is-valid-disabled="!isValid"
    @ok-pushed="createNewProject"
  >
    <form-new-project
      @nameUpdated="nameUpdated"
      @sizeUpdated="sizeUpdated"
    />
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import formNewProject from "../Form/FormNewProject";

export default {
  components: {
    buttonDialogContainer,
    formNewProject,
  },
  data() {
    return {
      name: "",
      size: {
        width: "",
        height: "",
      },
    };
  },
  computed: {
    isValid() {
      if (!isNaN(this.size.width) && !isNaN(this.size.height)) {
        if (this.size.width > 0 && this.size.height > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    createNewProject() {
      this.$emit("newProject", this.name, {
        x: 0,
        y: 0,
        width: this.size.width,
        height: this.size.height,
        scale: {
          x: 1,
          y: 1,
        },
      });
    },
    nameUpdated(val) {
      this.name = val;
    },
    sizeUpdated(val) {
      this.size = val;
    },
  },
};
</script>

<style></style>
